// extracted by mini-css-extract-plugin
export default {"paddingTop":"BalancePage_paddingTop__lXquw"};